import {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image2 from "../../../../assets/images/Blog59/image2.png";
import image9 from "../../../../assets/images/Blog59/image9.png";
import image10 from "../../../../assets/images/Blog59/image10.png";
import image17 from "../../../../assets/images/Blog59/image17.png";
import image22 from "../../../../assets/images/Blog59/image22.png";
import image25 from "../../../../assets/images/Blog59/image25.png";
import image27 from "../../../../assets/images/Blog59/image27.png";
import image28 from "../../../../assets/images/Blog59/image28.png";
import image34 from "../../../../assets/images/Blog59/image34.png";
import image40 from "../../../../assets/images/Blog59/image40.png";
import image42 from "../../../../assets/images/Blog59/image42.png";
import image43 from "../../../../assets/images/Blog59/image43.png";
import image45 from "../../../../assets/images/Blog59/image45.png";
import image50 from "../../../../assets/images/Blog59/image50.png";
import image53 from "../../../../assets/images/Blog59/image53.png";
import image54 from "../../../../assets/images/Blog59/image54.png";
import image64 from "../../../../assets/images/Blog59/image64.png";
import image73 from "../../../../assets/images/Blog59/image73.png";
import image74 from "../../../../assets/images/Blog59/image74.png";
import BlogImagePopper from "./BlogImageLarge";

const Blog59 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – March 9, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Energy Shock Emerges, Inflation Sensitivity Returns to the Fore</p>
        <p>
          Markets move into the second week of March, navigating an environment where geopolitical developments and energy markets have begun to reshape macro sensitivities. Price action across assets
          suggests that positioning has become more cautious as markets adjust to higher energy prices and evolving geopolitical developments.
        </p>
        <p>
          Beneath the surface, participation appears increasingly selective. Commodity volatility has lifted from previously suppressed levels, currency dynamics are adjusting to global trade
          sensitivities, and equity indices are approaching key technical thresholds. The resulting price action reflects markets becoming increasingly responsive to energy dynamics and inflation
          risk.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Energy Repricing Meets Structural Stability</p>

              <p>
                Equity markets have been absorbing recent developments without a broad deterioration in price structure but lost the 100dma and wicked the 200dma on the SPX overnight. Recent
                developments in energy markets have amplified macro sensitivity across asset classes, particularly as oil prices surged sharply following renewed geopolitical tensions.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="oil cathartic surge?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The move in crude followed growing concerns around transport disruptions and geopolitical tensions affecting the Strait of Hormuz. Reduced maritime activity and heightened military
                developments in the region increased the perceived risk premium embedded in energy markets.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="Strait of Hormuz seeing action"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This shift in energy pricing has broader implications across global markets. Economies heavily dependent on imported energy face potential inflation pressure, while resource exporters
                may benefit from higher commodity prices.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="oil winners and losers"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Despite this volatility, equity markets have not yet experienced widespread structural damage. Instead, recent behaviour suggests markets are adjusting to geopolitical developments and
                energy price volatility rather than responding to a clear deterioration in macro data.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Inflation Sensitivity Re-emerges</p>
              <p>
                Energy markets have become a central macro variable once again. Rising crude prices introduce renewed sensitivity around inflation expectations, particularly through transportation and
                energy cost channels.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt="oil levels and CPI impact"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This dynamic increases sensitivity around inflation expectations as energy prices rise. Inflation pressures linked to commodity prices can influence expectations around monetary
                policy, especially when economic data remains mixed.
              </p>
              <p>
                Labour market data continues to show uneven signals. Employment growth softened in the latest reading, though some interpretations suggest technical factors may have influenced the
                result.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="NFP monthly changes"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Consumer spending data reinforced the mixed macro picture. While several discretionary categories weakened, the retail control group — which feeds into GDP calculations — remained
                positive, indicating that underlying consumption has not materially deteriorated.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="retail sales"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Manufacturing indicators also strengthened, with both the ISM manufacturing index and new orders components improving.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image25}
                    alt="ISM manu positives"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image25)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Outside the United States, policy dynamics remain uneven. China has lowered growth expectations but has not yet deployed significant stimulus measures, leaving fiscal support
                relatively limited.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt="China spending underwhelming"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>Market structure across equities remains broadly intact, though several indicators suggest momentum may be slowing.</p>
              <p>Currency markets are beginning to reflect these shifting dynamics. The U.S. dollar is approaching important technical levels as positioning dynamics continue to evolve.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt="DXY breakout?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Volatility dynamics have also changed meaningfully in energy markets. After a prolonged period of subdued fluctuations, oil volatility has surged alongside the sharp repricing in crude
                prices.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image53}
                    alt="oil vix surging"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image53)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Equity indices are now approaching key technical levels. The S&P 500 recently interacted with major moving averages that often act as important inflection points for trend continuation
                or reversal.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image64}
                    alt="SPX loses 100dma and touches 200dma all done??"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image64)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Options positioning further reflects growing caution. Skew dynamics suggest increased demand for downside protection even while indices remain broadly supported.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="does sock skew need to catch up with index bearishness?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Energy Volatility and Mixed Macro Signals</p>
              <p>
                Recent market developments reflected a shift in attention toward energy markets and geopolitical developments, while macro data continued to provide mixed signals regarding economic
                momentum.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br> Labour market data delivered a softer reading, though the weakness may partially reflect technical adjustments rather than a structural deterioration in employment
                    conditions.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image17}
                        alt="NFP monthly changes"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image17)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>Growth projections were lowered while fiscal stimulus remained limited, suggesting policymakers are adopting a cautious approach toward economic support.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image27}
                        alt="China spending underwhelming"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image27)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Equity markets continued to exhibit concentrated leadership, with flows rotating through the most liquid exposures rather than broad market selling.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br></br>Energy markets became the focal point as crude prices surged following geopolitical developments and concerns surrounding transport routes and production dynamics.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image2}
                        alt="oil cathartic surge?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image2)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image28}
                        alt="oil levels and CPI impact"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image28)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br></br> Crypto markets continue to trade around key technical structures while momentum signals remain mixed.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image40}
                        alt="ETH TA positive?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image40)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image42}
                        alt="tokenised gold volume surge"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image42)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Crude markets reacted sharply to developments surrounding the Strait of Hormuz and broader geopolitical tensions affecting the region.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image9}
                        alt="Strait of Hormuz seeing action"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image9)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week centres on <span className="highlightedText">the US CPI on Wednesday, which will be closely watched by markets.</span> Growth signals will also be watched through{" "}
                <span className="highlightedText">Japan's GDP early in the week</span> and <span className="highlightedText">UK and US GDP releases on Friday,</span> alongside{" "}
                <span className="highlightedText">JOLTS job openings and Michigan consumer sentiment.</span>
              </p>
              <p className="highlightedText">Monday, March 9</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> CPI (MoM), CPI (YoY), PPI (YoY)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> GDP (Q4), GDP Annualised, Private Consumption, Capital Expenditure
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> Leading Index, Coincident Indicator, Economy Watchers Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> German Factory Orders, German Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Sentix Investor Confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> CB Employment Trends Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> NY Fed 1-Year Consumer Inflation Expectations
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, March 10</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> BRC Retail Sales Monitor
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Australia:</span> NAB Business Confidence, Building Approvals
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Imports, Exports, Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> German Trade Balance, German Imports and Exports
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">France:</span> Trade Balance and Current Account
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> NFIB Small Business Optimism
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Existing Home Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> API Weekly Crude Oil Stocks
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan:</span> PPI (MoM, YoY)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, March 11</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany:</span> CPI (MoM, YoY), HICP
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> CPI (MoM, YoY), Core CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Real Earnings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Federal Budget Balance
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, March 12</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Initial Jobless Claims, Continuing Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Housing Starts and Building Permits
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Natural Gas Storage
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Atlanta Fed GDPNow
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, March 13</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK:</span> GDP (MoM, YoY), Industrial Production, Manufacturing Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> GDP (QoQ) and GDP Price Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Core PCE Price Index and PCE Price Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Personal Income and Personal Spending
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Durable Goods Orders
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada:</span> Employment Change and Unemployment Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> JOLTS Job Openings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Michigan Consumer Sentiment and Inflation Expectations
                  </p>
                </li>
              </ul>
              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image74}
                    alt="CB meetings to come in March"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image74)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image73}
                    alt="EW 090326"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image73)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Energy Sensitivity Returns</p>
              <p>Markets are adjusting to the re-emergence of energy as a dominant macro driver, introducing renewed sensitivity around inflation and policy expectations.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br> Indices remain structurally supported but are approaching technical levels where positioning and sentiment may play a larger role in determining short-term direction.
                    Could an input cost like oil de-rail earnings growth for 2026/7? That is key now.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Precious metals continue to experience mixed flows as interest rate dynamics and macro positioning influence
                    investor allocation decisions. Recent ETF outflows may be the factor for weakness here.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Digital assets remain closely linked to broader liquidity conditions and risk sentiment rather than functioning as
                    independent defensive assets.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>Energy prices, inflation expectations, and policy responses are increasingly shaping global market dynamics.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                The current environment reflects a market adjusting to new variables rather than one undergoing structural deterioration. Positioning dynamics may continue to drive episodic volatility
                as markets respond to geopolitical developments and energy price movements.
              </p>
              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image43}
                    alt="Gold ETF outflows driving price weakness?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image43)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt="war performance for SPX"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image54}
                    alt="SPX recovers from oil shocks but has drawdowns"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image54)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1FnrWOBKyOFoAoDLQTLbj1MzdlpFpI5-ypXjwXKwRnHY/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog59;
